import api from '@/core/apiclient'
import { actionTypes } from '@/core/constants'
import { DownloadFile } from '@/core/utils'

export default {
	async [actionTypes.PEDIDO.DOCUMENTOS.BUSCAR_POR_FILTRO]({ state }, idPedido) {
		const { filtro, paginacao, modalPenalidade } = state
		const { data } = await api.documentosPedido.buscarListagem(filtro, paginacao, idPedido, modalPenalidade)
		return data
	},
	async [actionTypes.PEDIDO.DOCUMENTOS.EXCLUIR_DOCUMENTO_OU_ANEXO](context, documentoAnexo) {
		return await api.documentosPedido.excluir(documentoAnexo)
	},
	async [actionTypes.PEDIDO.DOCUMENTOS.BAIXAR_DOCUMENTO_ANEXO](context, documento) {
		const response = await api.documentosPedido.baixar(documento)
		const headers = response.headers
		DownloadFile.downloadArrayBuffer(response.data, headers.filename, headers['content-type'], headers.extension)
	},
	async [actionTypes.PEDIDO.DOCUMENTOS.BUSCAR_EMAIL_FORNECEDOR](context, idDocumento) {
		const {data} = await api.documentosPedido.buscarEmailFornecedor(idDocumento)
		return data
	},
	async [actionTypes.PEDIDO.DOCUMENTOS.ENVIAR_FORNECEDOR](context, obj) {
		await api.documentosPedido.enviarDocumentoOrdemUtilizacaoParaFornecedor(obj)
	},
}
